enum Roles {
    SUPER_ADMIN = 'super_admin',
    ADMIN = 'admin',
    USER = 'user',
    SELLER = 'seller'
  }

export default Roles;
